<template>
    <div>
        <NavbarStyleTwo />
        <PageTitle pageTitle="Webentwicklung" pageDesc="Von der Idee zur fertigen Webseite" />
        <WebentwicklungDetails />
        <Footer :showDivider="true" />
    </div>
</template>

<script>
import { useHead } from '@vueuse/head';
import NavbarStyleTwo from '../Layouts/NavbarStyleTwo';
import PageTitle from '../Common/PageTitle';
import WebentwicklungDetails from '../SingleService/WebentwicklungDetails'
import Footer from '../Layouts/Footer'

export default {
    name: 'WebentwicklungPage',
    setup() {
        useHead({
            title: 'Webentwicklung Wien - Professionelle Webseiten | Benovium',
            meta: [
                { name: 'description', content: 'Professionelle Webentwicklung in Wien. Landingpages, Unternehmenswebseiten, Webanwendungen mit Vue.js, React und TypeScript. Persönliche Betreuung von A-Z.' },
                { property: 'og:title', content: 'Webentwicklung Wien - Benovium' },
                { property: 'og:description', content: 'Professionelle Webseiten für Ihr Unternehmen.' },
                { property: 'og:url', content: 'https://benovium.com/services/webentwicklung' },
            ],
            link: [
                { rel: 'canonical', href: 'https://benovium.com/services/webentwicklung' }
            ]
        });
    },
    components: {
        NavbarStyleTwo,
        PageTitle,
        WebentwicklungDetails,
        Footer,
    }
};
</script>
